import { api, updateAxiosHeader } from './axios';
import {
  getHeaderConfig,
  setHeaderConfig
} from './utils';

export async function login(data) {
    let headerConfig = getHeaderConfig();
    let response = await api
      .post('user/auth/login', data)
      .then((response) => {
        headerConfig = {
          headers: {
            'Content-Type': 'multipart/form-data',
            "Accept": 'application/json',
            'Accept-Language':'ar',
            'Authorization': 'Bearer ' + response.data.data.token,
          },
        };
        setHeaderConfig(headerConfig);
        updateAxiosHeader();
        return response;
      });
    return response;
  }
  